exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero.is-success {\n  background: #F2F6FA;\n}\n\n.hero .nav,\n.hero.is-success .nav {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.box {\n  margin-top: 5rem;\n}\n\n.avatar {\n  margin-top: -70px;\n  padding-bottom: 20px;\n}\n\n.avatar img {\n  padding: 5px;\n  background: #fff;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n  box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n}\n\ninput {\n  font-weight: 300;\n}\n\np {\n  font-weight: 700;\n}\n\np.subtitle {\n  padding-top: 1rem;\n}\n\n.hero {\n  margin-top: 30px;\n}\n\n.hero-body {\n  background-color: rgba(48, 48, 48, 0.1);\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/login/login.component.css
// module id = ../../../../../src/app/components/login/login.component.css
// module chunks = main